import { useState, useEffect } from 'react';
import ProfilePicture from './ProfilePicture';
import picture from '../images/profilePicture.jpeg';

function Typewriter({ text, speed = 25, className = '' }) {
	const [displayed, setDisplayed] = useState('');

	useEffect(() => {
		let i = 0;
		const interval = setInterval(() => {
			setDisplayed(text.slice(0, i));
			i++;
			if (i > text.length) clearInterval(interval);
		}, speed);

		return () => clearInterval(interval);
	}, [text, speed]);

	return (
		<span className={className}>
			{displayed}
			<span className="cursor">|</span>
		</span>
	);
}

export default function Profile() {
	const BIRTH_DATE = new Date('2002-12-27');
	function getAge(d) {
		const t = new Date();
		let a = t.getFullYear() - d.getFullYear();
		if (
			t.getMonth() < d.getMonth() ||
			(t.getMonth() === d.getMonth() && t.getDate() < d.getDate())
		)
			a--;
		return a;
	}
	const age = getAge(BIRTH_DATE);

	const terminalText = `> const developer = {
  name: "Nathan Lia",
  role: "Software Developer",
  stack: ["React", "C#", "Unity", "Docker"],
};`;

	return (
		<section
			id="about"
			className="profile-hero"
			style={{ scrollMarginTop: '80px' }}
		>
			<div className="profile-avatar-col">
				<div className="profile-avatar">
					<ProfilePicture src={picture} alt="Nathan Lia" />
				</div>
				<p
					style={{
						fontSize: '12px',
						letterSpacing: '0.12em',
						color: 'var(--accent)',
						textTransform: 'uppercase',
						textAlign: 'center',
					}}
				>
					Malta · {age} years old
				</p>
				<div className="profile-tags">
					<span className="profile-tag">Game Dev</span>
					<span className="profile-tag">Fullstack</span>
					<span className="profile-tag">Unity</span>
				</div>
			</div>

			<div className="profile-text-col">
				<h1 className="profile-name">
					Nathan
					<br />
					Lia
				</h1>
				<p className="profile-bio">
					I'm a Maltese software developer fluent in <strong>English</strong>{' '}
					and <strong>Maltese</strong>, with hands-on experience in{' '}
					<strong>C#</strong>, <strong>JavaScript</strong>,{' '}
					<strong>Python</strong>, and <strong>Java</strong>. In my current role
					I work with <strong>Azure Pipelines</strong>, <strong>CI/CD</strong>,
					and <strong>Docker</strong> alongside <strong>React</strong>,{' '}
					<strong>C#</strong> and most recently <strong>Phaser.js</strong>. My
					BSc thesis focused on{' '}
					<strong>simulating crowd behaviour in virtual environments</strong>{' '}
					using A* pathfinding and ML-Agents.
				</p>
				<p className="profile-bio">
					Beyond code, I spent <strong>8 years as a scout</strong> including a
					year as <strong>scout leader</strong> and lead secretary which shaped
					my teamwork, mentoring, and organisational skills. Outside of work, I
					enjoy playing guitar, piano, bass, and drums, and exploring new games.
				</p>
			</div>

			<div className="hero-terminal">
				<div className="terminal-header">
					<span className="dot red" />
					<span className="dot yellow" />
					<span className="dot green" />
				</div>

				<pre className="terminal-body">
					<Typewriter text={terminalText} />
				</pre>
			</div>
		</section>
	);
}
